import { Filter } from 'common/repositories/common.model';
import { SelectTypeEnum } from 'legacy-modules/selects';
import AgentFilterSelectInput from 'legacy-modules/selects/agent-select';
import BankAccountFilterSelectInput from 'legacy-modules/selects/bank-account-select';
import BonusPeriodSelectInput from 'legacy-modules/selects/bonus-period-select';
import CashAccountFilterSelectInput from 'legacy-modules/selects/cash-account-select';
import CustomerFilterSelectInput from 'legacy-modules/selects/customer-select';
import EmployeeSelectInput from 'legacy-modules/selects/employee-select';
import GuestFilterSelectInput from 'legacy-modules/selects/guest-select';
import ReportSelectInput from 'legacy-modules/selects/report-select';
import SaleTypeSelectInput from 'legacy-modules/selects/sale-type-select';

export const SelectComponent = (
  filter: Filter,
  isUseResponseOptions: boolean,
) => {
  if (isUseResponseOptions) return null;

  switch (filter.name) {
    case SelectTypeEnum.operator:
    case SelectTypeEnum.sales:
    case SelectTypeEnum.lead:
    case SelectTypeEnum.admin:
    case SelectTypeEnum.document_admin:
    case SelectTypeEnum.employee:
    case SelectTypeEnum.employee_id:
      return EmployeeSelectInput;
    case SelectTypeEnum.agent:
      return AgentFilterSelectInput;
    case SelectTypeEnum.bank_account:
      return BankAccountFilterSelectInput;
    case SelectTypeEnum.bonus_period:
      return BonusPeriodSelectInput;
    case SelectTypeEnum.cash_account:
      return CashAccountFilterSelectInput;
    case SelectTypeEnum.customer:
      return CustomerFilterSelectInput;
    case SelectTypeEnum.guest:
      return GuestFilterSelectInput;
    case SelectTypeEnum.report:
      return ReportSelectInput;
    case SelectTypeEnum.type:
      return SaleTypeSelectInput;
  }

  return null;
};
